const PAYMENT_PROVIDERS = {
  vitesse: {
    is_fund_account_required: true,
    static_fund_account_id_key: 'vitesse_account_id',
  },
  stripe: {},
} as const;

export default PAYMENT_PROVIDERS;
